import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon CocktailDuotone
 */
export const CocktailDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M89,41.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3S76.8,60.8,76.8,54c0,0,0,0,0,0C76.8,47.2,82.2,41.8,89,41.8  M89,31.7c-12.3,0-22.2,10-22.2,22.3s10,22.2,22.2,22.2s22.2-10,22.2-22.2S101.3,31.7,89,31.7z"
      fill="currentColor"
    />
    <path
      d="M89,189.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C76.8,195.2,82.2,189.8,89,189.8 M89,179.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2S101.3,179.8,89,179.8 L89,179.8z"
      fill="currentColor"
    />
    <path
      d="M113,109.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C100.8,115.2,106.2,109.8,113,109.8 M113,99.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2S125.3,99.8,113,99.8z "
      fill="currentColor"
    />
    <path
      d="M167,57.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C154.8,63.2,160.2,57.8,167,57.8 M167,47.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C189.2,57.7,179.3,47.8,167,47.8z"
      fill="currentColor"
    />
    <path
      d="M163,155.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C150.8,161.2,156.2,155.8,163,155.8 M163,145.8c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C185.2,155.7,175.3,145.8,163,145.8z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M89,41.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3S76.8,60.8,76.8,54c0,0,0,0,0,0 C76.8,47.2,82.2,41.8,89,41.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M89,189.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C76.8,195.2,82.2,189.8,89,189.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M113,109.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C100.8,115.2,106.2,109.8,113,109.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M167,57.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C154.8,63.2,160.2,57.8,167,57.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M163,155.8c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C150.8,161.2,156.2,155.8,163,155.8"
      fill="currentColor"
    />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default CocktailDuotone;
